const featureIsEnabled = flagName => (process.env.REACT_APP_FEATURE_FLAGS || '').includes(flagName);

const featureFlags = {
    sketchOrderNotifications: featureIsEnabled('sketchOrderNotifications'),
    sketchOrderDeliveryOptions: featureIsEnabled('sketchOrderDeliveryOptions'),
    vexcelImagery: featureIsEnabled('vexcelImagery'),
    parcelLines: featureIsEnabled('parcelLines'),
};

export default featureFlags;
